// src/components/Users/UserForm.js
import React, { useState, useEffect, useContext } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import {
  Container,
  TextField,
  Button,
  Typography,
  Box,
  Alert,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from '@mui/material';
import { createUsuario, updateUsuario, getUsuarios } from '../../services/api';
import { AuthContext } from '../../contexts/AuthContext';

const UserForm = () => {
  const [usuario, setUsuario] = useState({
    id: '',
    username: '',
    password: '',
    rol: '',
    estado: 'activo',
  });
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const { id } = useParams(); // Para editar
  const { user } = useContext(AuthContext);

  useEffect(() => {
    if (id) {
      // Si hay un ID, es edición. Obtener datos del usuario.
      const fetchUsuario = async () => {
        try {
          const data = await getUsuarios();
          if (data.success) {
            const existingUsuario = data.data.find((usr) => usr.id === id);
            if (existingUsuario) {
              setUsuario(existingUsuario);
            } else {
              setError('Usuario no encontrado');
            }
          } else {
            setError('Error al obtener usuario');
          }
        } catch (err) {
          setError(err.error || 'Error al obtener usuario');
        }
      };
      fetchUsuario();
    }
  }, [id]);

  const handleChange = (e) => {
    setUsuario({ ...usuario, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    try {
      if (id) {
        // Actualizar usuario
        const data = await updateUsuario(usuario);
        if (data.success) {
          navigate('/users');
        } else {
          setError('Error al actualizar usuario');
        }
      } else {
        // Crear usuario
        const data = await createUsuario(usuario);
        if (data.success) {
          navigate('/users');
        } else {
          setError('Error al crear usuario');
        }
      }
    } catch (err) {
      setError(err.error || 'Error en la operación');
    }
  };

  return (
    <Container maxWidth="sm">
      <Box mt={4} p={4} boxShadow={3}>
        <Typography variant="h5" gutterBottom>
          {id ? 'Editar Usuario' : 'Crear Usuario'}
        </Typography>
        {error && <Alert severity="error">{error}</Alert>}
        <form onSubmit={handleSubmit}>
          {/* ID solo para edición */}
          {id && (
            <TextField
              label="ID"
              variant="outlined"
              fullWidth
              margin="normal"
              name="id"
              value={usuario.id}
              onChange={handleChange}
              disabled
            />
          )}
          <TextField
            label="Usuario"
            variant="outlined"
            fullWidth
            margin="normal"
            name="username"
            value={usuario.username}
            onChange={handleChange}
            required
          />
          <TextField
            label="Contraseña"
            variant="outlined"
            type="password"
            fullWidth
            margin="normal"
            name="password"
            value={usuario.password}
            onChange={handleChange}
            required={!id} // Requerido solo para creación
          />
          <FormControl variant="outlined" fullWidth margin="normal" required>
            <InputLabel id="rol-label">Rol</InputLabel>
            <Select
              labelId="rol-label"
              label="Rol"
              name="rol"
              value={usuario.rol}
              onChange={handleChange}
            >
              <MenuItem value="admin">Admin</MenuItem>
              <MenuItem value="user">User</MenuItem>
              {/* Agrega más roles según tu configuración */}
            </Select>
          </FormControl>
          <FormControl variant="outlined" fullWidth margin="normal" required>
            <InputLabel id="estado-label">Estado</InputLabel>
            <Select
              labelId="estado-label"
              label="Estado"
              name="estado"
              value={usuario.estado}
              onChange={handleChange}
            >
              <MenuItem value="activo">Activo</MenuItem>
              <MenuItem value="inactivo">Inactivo</MenuItem>
            </Select>
          </FormControl>
          <Box mt={2}>
            <Button type="submit" variant="contained" color="primary" fullWidth>
              {id ? 'Actualizar' : 'Crear'}
            </Button>
          </Box>
        </form>
      </Box>
    </Container>
  );
};

export default UserForm;
